var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 13.58L7.5 10L5.2 6.42L9.32 7.5L12 4.21L12.26 8.46L16.2 10L12.26 11.54L12 15.79L9.32 12.5M10 18C10.5304 18 11.0391 18.2107 11.4142 18.5858C11.7893 18.9609 12 19.4696 12 20L16 20C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18L18 2C18 1.46957 17.7893 0.960859 17.4142 0.585786C17.0391 0.210714 16.5304 -6.42368e-08 16 -8.74228e-08L12 -2.62268e-07C12 0.530433 11.7893 1.03914 11.4142 1.41421C11.0391 1.78929 10.5304 2 10 2C9.46957 2 8.96086 1.78929 8.58579 1.41421C8.21071 1.03914 8 0.530433 8 -4.37114e-07L4 -6.11959e-07C3.46957 -6.35145e-07 2.96086 0.210713 2.58579 0.585786C2.21071 0.960858 2 1.46957 2 2L2 18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20L8 20C8 19.4696 8.21071 18.9609 8.58579 18.5858C8.96086 18.2107 9.46957 18 10 18Z",
    fill: "#F4F1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon01.7ad199dd2d753c1950702076ee69ad7b.svg";
export { ForwardRef as ReactComponent };